import { HeadingProps } from "./headings.model";

const Heading: React.FunctionComponent<HeadingProps & React.HTMLAttributes<HTMLElement>> = ({
    level: level,
    tag: DynamicHeading = "h" + level,
    children,
    ...rest
}) => {
    return <DynamicHeading {...rest}>{children}</DynamicHeading>;
};

export default Heading